import React, {createContext, useContext, useEffect, useRef} from 'react';

import {useThreadHistory} from './useThreadHistory';

type ThreadHistoryValue = ReturnType<typeof useThreadHistory>;

const ThreadHistoryContext = createContext<ThreadHistoryValue | null>(null);

export const ThreadHistoryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const history = useThreadHistory();

  const didLoadRef = useRef(false);
  useEffect(() => {
    if (didLoadRef.current) {
      return;
    }
    didLoadRef.current = true;
    history.loadInitial();
  }, [history]);

  return (
    <ThreadHistoryContext.Provider value={history}>
      {children}
    </ThreadHistoryContext.Provider>
  );
};

export const useThreadHistoryContext = () => {
  const ctx = useContext(ThreadHistoryContext);
  if (!ctx) {
    throw new Error(
      'useThreadHistoryContext must be used inside <ThreadHistoryProvider>'
    );
  }
  return ctx;
};
